module.exports = __webpack_public_path__ + "static/media/ClockCircleIcon.50ad1cca.svg";